<template>
  <div>
    <default-dialog fullscreen :dialog="dialog" :loading="loading.company">
      <template slot="title">
        Detalhes da empresa
      </template>
      <template slot="content">
        <v-container>
          <v-tabs v-model="tab" color="white" slider-color="primary" light grow icons-and-text class="pt-3">
            <v-tab ripple :class="tab == 0 ? 'primary--text' : ''">
              CADASTROS
              <v-icon :large="tab == 0" :color="tab == 0 ? 'primary' : ''">{{ 'mdi-clipboard' }}</v-icon>
            </v-tab>
            <v-tab ripple :class="tab == 1 ? 'primary--text' : ''" disabled>
              OUTROS
              <v-icon :large="tab == 1" :color="tab == 1 ? 'primary' : ''">{{ 'mdi-dots-horizontal' }}</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" touchless>
            <card-loading class="my-3" v-if="loading.company"></card-loading>
            <v-tab-item :value="0" v-if="!loading.company && company['data']">
              
              <v-expansion-panels multiple flat class="ml-4 mr-15 pr-10 pt-3" active-class="elevation-4" popout v-model="panel">
                <v-expansion-panel class="exp-panel" ripple>
                  <v-expansion-panel-header class="red--text font-weight-bold">
                    <div>
                      <v-icon size="19" color="red">mdi-information</v-icon>
                      Informações básicas
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <card-loading class="my-3" v-if="loading.infos"></card-loading>
                    <v-card flat>
                      <v-card-title class="d-flex align-center justify-end">
                        <f-btn edit
                          small class="ml-4 mt-3" 
                          @click="is_editing.infos = true" 
                          v-if="!is_editing.infos"
                        ></f-btn>
                        <f-btn cancel
                          small class="ml-4 mt-3" 
                          @click="() => { is_editing.infos = false}" 
                          v-if="is_editing.infos"
                        ></f-btn>
                        <f-btn save 
                          small class="ml-4 mt-3" 
                          @click="() => { updateCompany(company.data.attributes) }" 
                          v-if="is_editing.infos"
                        ></f-btn>
                      </v-card-title>
                      <v-card-text>
                        <div v-if="!loading.infos && company['data']">
                          <company-form :company="company.data.attributes" :read_only="!is_editing.infos"></company-form>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
          
                <v-expansion-panel class="exp-panel" ripple v-for="(item, idx) in company.data.attributes.addresses">
                  <v-expansion-panel-header class="red--text font-weight-bold">
                    <div>
                      <v-icon size="19" color="red">mdi-map</v-icon>
                      Endereço {{ idx > 0 ? (idx + 1) : ''}}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <card-loading class="my-3" v-if="loading.addresses"></card-loading>
                    <v-card flat>
                      <v-card-title class="d-flex align-center justify-end">
                        <f-btn edit
                          small class="ml-4 mt-3" 
                          @click="is_editing.addresses = true" 
                          v-if="!is_editing.addresses"
                        ></f-btn>
                        <f-btn cancel
                          small class="ml-4 mt-3" 
                          @click="() => { is_editing.addresses = false }" 
                          v-if="is_editing.addresses"
                        ></f-btn>
                        <f-btn save
                          small class="ml-4 mt-3" 
                          @click="() => { updateCompany(item, 'addresses_attributes');}" 
                          v-if="is_editing.addresses"
                        ></f-btn>

                      </v-card-title>
                      <v-card-text>
                        <div v-if="!loading.addresses">
                          <address-form :address="item" :read_only="!is_editing.addresses"></address-form>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
          
                <v-expansion-panel class="exp-panel" ripple v-for="(item, idx) in company.data.attributes.contacts">
                  <v-expansion-panel-header class="red--text font-weight-bold">
                    <div>
                      <v-icon size="19" color="red">mdi-account-box</v-icon>
                      Contato {{ idx > 0 ? (idx + 1) : ''}}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <card-loading class="my-3" v-if="loading.contacts"></card-loading>
                    <v-card flat> 
                      <v-card-title class="d-flex align-center justify-end">
                        <f-btn edit
                          small class="ml-4 mt-3" 
                          @click="is_editing.contacts = true" 
                          v-if="!is_editing.contacts"
                        ></f-btn>
                        <f-btn cancel
                          small class="ml-4 mt-3" 
                          @click="() => { is_editing.contacts = false }" 
                          v-if="is_editing.contacts"
                        ></f-btn>
                        <f-btn save
                          small class="ml-4 mt-3" 
                          @click="() => { updateCompany(item, 'contacts_attributes'); }" 
                          v-if="is_editing.contacts"
                        ></f-btn>
                      </v-card-title>
                      <v-card-text>
                        <div v-if="!loading.contacts">
                          <contact-form :contact="item" :read_only="!is_editing.contacts"></contact-form> 
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="exp-panel" ripple>
                  <v-expansion-panel-header class="red--text font-weight-bold">
                    <div>
                      <v-icon size="19" color="red">mdi-qrcode</v-icon>
                      Pix da empresa
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <card-loading class="my-3" v-if="loading.pix"></card-loading>
                    <v-card flat>
                      <v-card-title class="d-flex align-center justify-end" v-if="false">
                        <f-btn edit
                          small class="ml-4 mt-3" 
                          @click="is_editing.pix = true" 
                          v-if="!is_editing.pix"
                        ></f-btn>
                        <f-btn cancel
                          small class="ml-4 mt-3" 
                          @click="() => { is_editing.pix = false}" 
                          v-if="is_editing.pix"
                        ></f-btn>
                        <f-btn save 
                          small class="ml-4 mt-3" 
                          @click="() => { updateCompany(company.data.attributes) }" 
                          v-if="is_editing.pix"
                        ></f-btn>
                      </v-card-title>
                      <v-card-text>
                        <div v-if="!loading.pix && company['data']">
                          <pix-gateway-form :gateway_key="company.data.attributes.gateway_key" :read_only="!is_editing.pix"></pix-gateway-form>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>

    
              </v-expansion-panels>
      
            </v-tab-item>
            <v-tab-item :value="1"> 
              <card-loading class="my-3" v-if="loading.company"></card-loading>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </template>
      <template slot="actions">
        <f-btn close @click="goBack()"></f-btn>
      </template>
    </default-dialog>
    <dialog-loading v-if="saving" loadingText="Salvando..."></dialog-loading>
  </div>
</template>


<script>
import Api from '@/api/index';
import getters from '@/_backoffice/_registrations/mixins/getters.js'

export default {
  name: "ShowCompany",
  mixins: [ getters ],
  components: {
    CompanyForm: () => import('./forms/CompanyForm.vue'), 
    PixGatewayForm: () => import('./forms/PixGatewayForm.vue'), 
    AddressForm: () => import('@/_backoffice/_registrations/components/shared/forms/AddressForm.vue'), 
    ContactForm: () => import("@/_backoffice/_registrations/components/shared/forms/ContactForm.vue"),
  },
  data() {
    return {
      tab: 0,
      dialog: true,
      saving: false,
      panel: [],
      company: {
        data:{
          attributes:{
            gateway_key: ''
          }
        }
      },
      loading: {
        company: false,
        infos: false,
        addresses: false,
        contacts: false,
        pix: false,
      },
      is_editing: {
        infos: false,
        addresses: false,
        contacts: false,
        pix: false,
      },
    }
  },
  methods: {
    async getData(){
      await this.getCompany()
    },
    async getCompany(){
      this.loading.company = true
      await Api.Company.show(this.$route.params.id).then(r => {
        this.company = r.data
        if(r.data.data.attributes.contacts.length == 0){
          this.company.data.attributes.contacts.push({
            telephone: '',
            email: '',
            comment: '',
          })
        }
        if(r.data.data.attributes.addresses.length == 0){
          this.company.data.attributes.addresses.push({
            zip: '',
            addr: '',
            neighborhood: '',
            complement: '',
            number: '',
            city: '',
            state: ''
          })
        }
      }).catch(err=>{
        console.log(err)
      }).finally(()=>{
        this.loading.company = false
      })
    },
    updateCompany(item, attr = null){
      this.swallConfirmation({
        title: 'Deseja atualizar informações da empresa?',
        icon: 'question',
      }).then( confirmed =>{
        if (confirmed ) {
          this.saving = true
    
          let company = { id: parseInt(this.company.data.id) }
          if(!attr){
            company['name'] = item.name
            company['fantasyName'] = item.fantasyName
            company['corporateName'] = item.corporateName
            company['CNPJ'] = item.CNPJ
          }else{
            company[attr] = [{...item}]
          }
          Api.Company.update(company).then(() => {
            this.addNotification({type: 'success',  msg: `Empresa atualizada.`})
          }).catch((err) => {
            this.addNotification({type: 'success',  msg: err})
          }).finally(() => {
            this.saving = false
            this.cancelEdits()
          })
        }
      })
    },
    cancelEdits(){
      this.is_editing = {
        infos: false,
        addresses: false,
        contacts: false
      }
    },
    goBack(){
      this.$router.push({name:"Companies"})
    },
  },
  mounted() {
    this.getData();
  },
}
</script>

<style scoped>
.exp-panel{
  border-bottom: solid #ddd 1px;
}
</style>